import HttpRequest from "./HttpRequest"

class MobileApplicationsService {

  baseUrl = '/cloud/v1/apps'
  httpRequest = new HttpRequest()

  async save(data) {
    if (data.id) {
      return this.httpRequest.put(`${this.baseUrl}/edit/${data.id}`, data)
    }
    return this.httpRequest.post(`${this.baseUrl}`, data)
  }

  async getAppById(id) {
    return this.httpRequest.get(`${this.baseUrl}/${id}`)
  }

  async getAllApplications() {
    return this.httpRequest.get(`${this.baseUrl}`)
  }

  async getAlertByIdentifier(identifier) {
    return this.httpRequest.get(`${this.baseUrl}/identifier/${identifier}`)
  }

  async deleteById(id) {
    return this.httpRequest.delete(`${this.baseUrl}/${id}`)
  }
}
export {MobileApplicationsService}



// WEBPACK FOOTER //
// ./src/services/MobileApplicationsService.js